import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/FloatingCart.css"; // Ensure this CSS file exists
import FloatingCartCard from "./FloatingCartCard";
import ScrollCard from "./ScrollCard";
import database from "../config/firebaseConfig";

const FloatingCart = ({ cart, isOpen, updateCartQuantity, setIsOpen, addToCart }) => {
    const [productsMap, setProductsMap] = useState({});
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [scrollPosition, setScrollPosition] = useState(0); // State for scrolling
    const navigate = useNavigate();

    const onNavigateToCart = () => navigate("/Cart");
    const onNavigateToCheckout = () => navigate("/Checkout");
    const toggleCartDetails = () => setIsOpen(!isOpen);

    const handleNavigation = (path) => navigate(path);

    const scrollLeft = () => {
        if (scrollPosition > 0) {
            setScrollPosition(prev => prev - 1);
        }
    };

    const scrollRight = () => {
        if (scrollPosition < 3) { // Stop at -825 (3 * 275)
            setScrollPosition(prev => prev + 1);
        }
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const snapshot = await database.ref("Products").once("value");
                if (snapshot.exists()) {
                    const allProducts = snapshot.val();
                    const productLookup = {};
                    Object.keys(allProducts).forEach((key) => {
                        productLookup[allProducts[key].Name] = allProducts[key];
                    });
                    setProductsMap(productLookup);
                }
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };
        fetchProducts();
    }, []);

    useEffect(() => {
        if (cart.length > 0) {
            const cartProductNames = cart.map(item => item.Name);
            const related = Object.values(productsMap).filter(product => !cartProductNames.includes(product.Name));
            setRelatedProducts(related.slice(0, 10)); // Display up to 10 related products
        }
    }, [cart, productsMap]);

    return (
        <div className="floating-cart-button">
            <button className="cart-icon" onClick={toggleCartDetails}>
                Cart
            </button>

            {isOpen && (
                <div className="cart-details">
                    {cart.length === 0 ? (
                        <p>No items in the cart.</p>
                    ) : (
                        <>
                            <div className="cart-container">
                                {cart.map((item, index) => (
                                    <div key={index}>
                                        <FloatingCartCard 
                                            key={index + "card"} 
                                            index={index} 
                                            item={item} 
                                            updateCartQuantity={updateCartQuantity} 
                                            onClick={() => handleNavigation(`/Product/${item.Name}`)} 
                                            products={productsMap} 
                                        />
                                        <hr key={index + "hr"} />
                                    </div>
                                ))}
                            </div>

                            <div className="scroll-more-products">
                                <div className="more-products-title">More Like This</div>
                                {relatedProducts.length > 0 ? (
                                    <div className="carousel-container">
                                        {scrollPosition > 0 && (
                                            <button className="scroll-button left" onClick={scrollLeft}>&lt;</button>
                                        )}
                                        <div 
                                            className="more-products-carousel"
                                            style={{
                                                transform: `translateX(-${scrollPosition * 275}px)`, // Adjust width for items
                                            }}
                                        >
                                            {relatedProducts.slice(scrollPosition, scrollPosition + 4).map((item, index) => (
                                                <div key={index} className="more-products-item">
                                                    <ScrollCard item={item} addToCart={addToCart} />
                                                </div>
                                            ))}
                                        </div>
                                        {scrollPosition < 3 && ( // Stop at -825 (3 * 275)
                                            <button className="scroll-button right" onClick={scrollRight}>&gt;</button>
                                        )}
                                    </div>
                                ) : (
                                    <p>No items available for this category</p>
                                )}
                            </div>
                        </>
                    )}

                    <button className="view-cart-button" onClick={onNavigateToCart}>
                        View Cart
                    </button>
                    {cart.length > 0 && (
                        <button className="view-cart-button" onClick={onNavigateToCheckout}>
                            Checkout
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default FloatingCart;
